import { Step } from "react-joyride"

const createSteps = (...steps: Step[]): Step[] => (
  steps.map((s) => ({
    ...s,
    disableBeacon: true,
    disableCloseOnEsc: true,
    disableOverlayClose: true,
    disableScrollParentFix: true,
    disableScrolling: true,
  })) as Step[]
)

export const year1: Step[] = createSteps({
  content: 'The voyagers section shows all the players that are currently in your game. It also summarizes key metrics about the player, including: Current Planet, Number of Owned Planets, Current Credit Rating, Income, and Equity.',
  target: '.jr-players'
}, {
  content: 'The goal of the game is to expand your empire and own 90% of the total equity in the game, while surviving financial recessions and pirates.',
  target: '.jr-players'
}, {
  content: 'Here is information regarding your ship. You have a cash balance, and a yearly income. Additionally, your ship has a population, which grows each year based on how many crew members are on the ship.',
  target: '.jr-ship'
})
